import React from 'react';
import './important.style.scss';


type TRoleImportantProps = {
  children : React.ReactNode,

}
const RoleImportant = ({children} : TRoleImportantProps) => {
  return (
    <>
      <p className="shop-role-important">{children}</p>
    </>
  );
};

export default RoleImportant;
